import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { PaymentMethodChargebeeTypes } from '../../enums/payment-methods.enum';
import { GetPaymentInformationResponseDto } from '../../interfaces/settings/payment-information.interface';
import * as PaymentActions from './payment.actions';

export const paymentFeatureKey = 'payment';

export interface State extends EntityState<GetPaymentInformationResponseDto> {
  // additional entities state properties
  paymentInformation: GetPaymentInformationResponseDto;
  loading: boolean;
  creating: boolean;
  updating: boolean;
  deleting: boolean;
  error: any;
}

export const adapter: EntityAdapter<GetPaymentInformationResponseDto> =
  createEntityAdapter<GetPaymentInformationResponseDto>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  paymentInformation: null,
  loading: false,
  creating: false,
  updating: false,
  deleting: false,
  error: null,
});

export const paymentReducer = createReducer(
  initialState,
  on(PaymentActions.loadPayment, (state) => ({ ...state, loading: true })),
  on(PaymentActions.loadPaymentSuccess, (state, action) => ({
    ...state,
    paymentInformation: action.paymentInformation,
    loading: false,
  })),
  on(PaymentActions.loadPaymentFailure, (state, action) => ({ ...state, error: action.error, loading: false })),
  on(PaymentActions.updateBillingAddress, (state, action) => ({ action, ...state, updating: true })),
  on(PaymentActions.updateBillingAddressSuccess, (state, action) => ({
    ...state,
    billingAddress: action.billingAddress,
    update: false,
  })),
  on(PaymentActions.updateBillingAddressFailure, (state, action) => ({
    ...state,
    error: action.error,
    updating: false,
  })),
  on(PaymentActions.setBankTransfer, (state, action) => ({ action, ...state, updating: true })),
  on(PaymentActions.setBankTransferSuccess, (state) => ({
    ...state,
    paymentInformation: {
      ...state.paymentInformation,
      paymentMethod: {
        type: PaymentMethodChargebeeTypes.INVOICE,
      },
    },
    update: false,
  })),
  on(PaymentActions.setBankTransferFailure, (state, action) => ({ ...state, error: action.error, updating: false })),
  on(PaymentActions.clearPayment, (state) => adapter.removeAll(state))
);

export const selectPaymentState = createFeatureSelector<State>(paymentFeatureKey);
export const selectPayment = createSelector(selectPaymentState, (state) => state.paymentInformation);
export const selectPaymentLoading = createSelector(selectPaymentState, (state) => state.loading);
